import { InlineResponse20063Result } from "../../bookmydesk-api-sdk-typescript-axios";
import { kSeats } from "./seats";
import { kSeatTags } from "./seat-tags";
import { currentDate, currentDateStr } from "./helpers";
import { dateFormat } from "../../src/components/DateSelector/dateSelector.constant";

export const kReservationsStatistics_Desk: InlineResponse20063Result = {
  seatCount: 254,
  parkingCount: 42,
  items: [
    {
      // Monday
      date: currentDateStr(),
      seatReservationsCount: 71,
      parkingSpotsClaimed: 9,
      seatTagLeaderboard: [
        {
          label: kSeatTags[0].label,
          percentage: 76,
          active: true,
        },
        {
          label: kSeatTags[1].label,
          percentage: 9,
          active: true,
        },
        {
          label: kSeatTags[2].label,
          percentage: 24,
          active: true,
        },
        {
          label: kSeatTags[3].label,
          percentage: 65,
          active: true,
        },
        {
          label: kSeatTags[4].label,
          percentage: 83,
          active: true,
        },
      ],
      mostUsed: [
        {
          percentage: 8,
          name: kSeats[0].name,
          reservations: 2,
        },
        {
          percentage: 25,
          name: kSeats[1].name,
          reservations: 2,
        },
        {
          percentage: 13,
          name: kSeats[2].name,
          reservations: 2,
        },
        {
          percentage: 51,
          name: kSeats[3].name,
          reservations: 2,
        },
        {
          percentage: 3,
          name: kSeats[4].name,
          reservations: 2,
        },
      ],
    },
    {
      // Sunday
      date: currentDate().subtract(1, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Saturday
      date: currentDate().subtract(2, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Friday
      date: currentDate().subtract(3, "day").format(dateFormat),
      seatReservationsCount: 32,
      parkingSpotsClaimed: 0,
    },
    {
      // Thursday
      date: currentDate().subtract(4, "day").format(dateFormat),
      seatReservationsCount: 93,
      parkingSpotsClaimed: 0,
    },
    {
      // Wednesday
      date: currentDate().subtract(5, "day").format(dateFormat),
      seatReservationsCount: 27,
      parkingSpotsClaimed: 0,
    },
    {
      // Tuesday
      date: currentDate().subtract(6, "day").format(dateFormat),
      seatReservationsCount: 105,
      parkingSpotsClaimed: 0,
    },
    {
      // Monday
      date: currentDate().subtract(7, "day").format(dateFormat),
      seatReservationsCount: 44,
      parkingSpotsClaimed: 0,
    },
  ],
};

export const kReservationsStatistics_Lunch: InlineResponse20063Result = {
  seatCount: 147,
  parkingCount: 0,
  items: [
    {
      // Monday
      date: currentDateStr(),
      seatReservationsCount: 48,
      parkingSpotsClaimed: 0,
    },
    {
      // Sunday
      date: currentDate().subtract(1, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Saturday
      date: currentDate().subtract(2, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Friday
      date: currentDate().subtract(3, "day").format(dateFormat),
      seatReservationsCount: 12,
      parkingSpotsClaimed: 0,
    },
    {
      // Thursday
      date: currentDate().subtract(4, "day").format(dateFormat),
      seatReservationsCount: 53,
      parkingSpotsClaimed: 0,
    },
    {
      // Wednesday
      date: currentDate().subtract(5, "day").format(dateFormat),
      seatReservationsCount: 8,
      parkingSpotsClaimed: 0,
    },
    {
      // Tuesday
      date: currentDate().subtract(6, "day").format(dateFormat),
      seatReservationsCount: 67,
      parkingSpotsClaimed: 0,
    },
    {
      // Monday
      date: currentDate().subtract(7, "day").format(dateFormat),
      seatReservationsCount: 15,
      parkingSpotsClaimed: 0,
    },
  ],
};

export const kReservationsStatistics_Meeting: InlineResponse20063Result = {
  seatCount: 108,
  parkingCount: 42,
  items: [
    {
      // Monday
      date: currentDateStr(),
      seatReservationsCount: 14,
      parkingSpotsClaimed: 8,
    },
    {
      // Sunday
      date: currentDate().subtract(1, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Saturday
      date: currentDate().subtract(2, "day").format(dateFormat),
      seatReservationsCount: 0,
      parkingSpotsClaimed: 0,
    },
    {
      // Friday
      date: currentDate().subtract(3, "day").format(dateFormat),
      seatReservationsCount: 4,
      parkingSpotsClaimed: 9,
    },
    {
      // Thursday
      date: currentDate().subtract(4, "day").format(dateFormat),
      seatReservationsCount: 25,
      parkingSpotsClaimed: 16,
    },
    {
      // Wednesday
      date: currentDate().subtract(5, "day").format(dateFormat),
      seatReservationsCount: 9,
      parkingSpotsClaimed: 4,
    },
    {
      // Tuesday
      date: currentDate().subtract(6, "day").format(dateFormat),
      seatReservationsCount: 33,
      parkingSpotsClaimed: 16,
    },
    {
      // Monday
      date: currentDate().subtract(7, "day").format(dateFormat),
      seatReservationsCount: 12,
      parkingSpotsClaimed: 7,
    },
  ],
};
